function ensureExists(value) {
  if (value === void 0 || value === null) {
    throw new Error(`Missing value.`);
  }
}
export {
  ensureExists
};
//# sourceMappingURL=ensureExists.js.map
